import Input from "react-input-mask";
import styles from "../Input/input.module.scss";

function MaskedInput({
  label,
  id,
  children,
  error,
  success,
  className,
  ...inputProps
}) {
  const inputId = id || label.toLowerCase().replace(/\s+/g, "-");

  const fieldClassName = error
    ? styles.fieldError
    : success
    ? styles.fieldSuccess
    : styles.field;

  // NOTE: invalid lint warning
  /* eslint-disable jsx-a11y/label-has-for */
  return (
    <div className={`${styles.input} input-${inputId} ${className}`}>
      {label && (
        <label htmlFor={inputId} className={styles.label}>
          {label}
        </label>
      )}

      <Input
        className={fieldClassName}
        id={inputId}
        name={inputId}
        {...inputProps}
      />

      {children}

      <div className={styles.error}>{error}</div>
    </div>
  );
}

export { MaskedInput };
